module.exports = __webpack_public_path__ + "img/TORBA1.b0182e2c.jpg";